export const dynamic = {
    marketingCopy: "MarketingCopy",
    cardsSection: "Cards",
    iconTilesSection: "IconTiles",
    tabbedSection: "TabbedSection",
    featuredArticles: "BlogStories",
    scrollingImagesSection: "ScrollingImages",
    downloadAndGetStarted: "DownloadAndGetStarted",
    faqs: "FrequentlyAskedQuestions",
    testimonialsSection: "Testimonials",
    loveShiftMed: "LoveShiftMed",
    legalCopy: "LegalCopy",
    accordionTabs: "AccordionTabs",
    awardCards: "AwardCards",
    zigZag: "ZigZag",
    exitBanner: "ExitBanner",
    awardsBanner: "AwardsBanner",
    standaloneForm: "StandaloneForm",
    stackedCards: "StackedCards",
    digitalCarousel: "DigitalCarousel",
    featuredBlogPost: "FeaturedBlogPost",
};

export const local = [
    "MonthlyEvents",
    "GreenhouseJobs",
    "CookiePreferences",
    "CategoriesFrequentlyAskedQuestions",
    "BlogPost",
    "ShareButtons",
    "PressReleasesList",
    "PressRelease",
    "InTheNewsLinks",
    "SavingsCalculatorForm",
    "NewsletterSubscriptionForm",
    "BlogPostsList",
    "IntercomLiveChat",
    "SubscribeNewsletterForm",
    "TableauEmbed",
    "WebinarFormEmbed",
    "CerosShiftmedExperience",
    "TextMeTheAppCTA",
    "MspSubVendorApplicationForm",
];
